var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.839,
    height: 70.854,
    viewBox: "0 0 76.839 70.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#A82047;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.581 -14.573)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M79.339,48.34A13.836,13.836,0,0,0,67.692,34.671V32.73a26.57,26.57,0,0,0-53.14,0v1.86a13.892,13.892,0,0,0,1.86,27.662h3.559a5.161,5.161,0,0,0,5.177-5.177V39.686a5.241,5.241,0,0,0-4.61-5.177V32.73a20.544,20.544,0,1,1,41.089,0v1.7A5.127,5.127,0,0,0,56.611,39.6v17.39a5.162,5.162,0,0,0,3.4,4.853,15.288,15.288,0,0,1-12.052,7.441A3.305,3.305,0,0,0,44.721,66.7H37.441a3.331,3.331,0,0,0-3.316,3.316v3.721a3.331,3.331,0,0,0,3.316,3.316h7.279a3.229,3.229,0,0,0,3.235-2.75A20.313,20.313,0,0,0,65.427,62.171,13.894,13.894,0,0,0,79.339,48.34ZM19.162,56.186h-2.75a7.846,7.846,0,0,1,0-15.691h2.75Zm46.265,0h-2.75V40.494h2.75a7.846,7.846,0,0,1,0,15.691Z",
    transform: "translate(9.081 8.373)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.e9b35b1ec4fb5622dd3ef62015b88227.svg";
export { ForwardRef as ReactComponent };